import React from "react";
import './About.css'
import playback from '../../Assets/play-icon.png'

const About = () => {
    const aboutData = [
        {
            id : 0,
            number : 83111,
            text : 'Jobs Created',
        },
        {
            id : 1,
            number : 259799,
            text : 'Skills Graduates',
        },
        {
            id : 2,
            number : 32028121,
            text : 'Total Visitors',
        },
        {
            id : 3,
            number : 1335007,
            text : 'Loan Applications Received',
        },
    ]
  return (
    <>
      <div className="about-container">
        <h1>A Few Facts About <br /><span> Our Programme</span></h1>
        <div className="about-card">
        <div className="about-box">
         {
            aboutData.map((items)=>{
              return(
                <div key={items.id} className="about-section">
                    <h2>{items.number}</h2>
                    <p>{items.text}</p>
                </div>
              )
            })
         }
         </div>
         <div className="about-video">
            <img src={playback} alt="play-back" />
         </div>
         </div>
      </div>
    </>
  );
};

export default About;
